const UserInfoInterface = {
  id: null,
  email: '',
  DefaultPage: '',
  PinCode: '',
  Nombre: '',
  Paterno: '',
  Materno: '',
  idDependencia: 0,
  Dependencia: '',
  NombreDependencia: '',
  idPerfil: 0,
  Perfil: '',
  idResponsabilidad: 0,
  idCargo: '',
  Cargo: '',
  Celular: '',
  Extension: '',
  idEstatus: 0,
  Estatus: '',
  TipoAcceso: '',
  UltimoAcceso: '',
  DeviceOS: '',
  DeviceID: '',
  FechaCreo: '',
  idUsuarioCreo: 0,
  RegistradoPor: '',
  FechaActualizo: '',
  idUsuarioActualizo: 0,
  idUsuarioPropietario: 0,
};

const UserProfileInterface = {
  id: null,
  Nombre: '',
  Paterno: '',
  Materno: '',
  Celular: '',
  Correo: '',
};

const UserPasswordInterface = {
  // id: 0,
  Password: '',
  Confirm: '',
};

const UserPinInterface = {
  // id: 0,
  PIN: '',
  Confirm: '',
};

const UserStatusInterface = {
  idEstatus: '',
  Motivo: '',
};

const UserAccessInterface = {
  idUsuario: null,
  TipoAcceso: '',
  FechaAcceso: '',
  HoraAcceso: '',
  IP: '',
  Navegador: '',
  Version: '',
  DeviceOS: '',
  Plataforma: '',
};

const UserRecoveryPasswd = {
  Celular: '',
  Contraseña: '',
  Confirmar: '',
};

const TypeRequest = {
  Celular: '',
  Nombre: '',
  Categoria: '',
  Comentarios: '',
};

export {
  UserInfoInterface,
  UserPasswordInterface,
  UserPinInterface,
  UserStatusInterface,
  UserAccessInterface,
  UserProfileInterface,
  UserRecoveryPasswd,
  TypeRequest,
};
